import { Controller } from "@hotwired/stimulus"

// A <details> that closes from a Cancel button or Escape and returns focus
// to its summary, so an inline confirmation behaves like a small dialog.
export default class extends Controller {
  connect() {
    this.boundKeydown = this.keydown.bind(this)
    this.element.addEventListener("keydown", this.boundKeydown)
  }

  disconnect() {
    this.element.removeEventListener("keydown", this.boundKeydown)
  }

  keydown(event) {
    if (event.key === "Escape" && this.element.open) {
      event.preventDefault()
      this.close()
    }
  }

  close() {
    this.element.open = false
    this.element.querySelector("summary")?.focus()
  }
}
